import React, { useEffect, useState } from "react";

// Tries each candidate URL in order (merchant image, then Open Food Facts).
// If none load, shows a placeholder tile with the item's initials.
const PALETTE = ["bg-blue-50 text-blue-700", "bg-emerald-50 text-emerald-700", "bg-amber-50 text-amber-700", "bg-rose-50 text-rose-700", "bg-violet-50 text-violet-700", "bg-sky-50 text-sky-700"];

function initials(text) {
  const words = String(text || "").replace(/[^A-Za-z0-9 ]/g, " ").split(/\s+/).filter(Boolean);
  return (words.slice(0, 2).map((w) => w[0]).join("") || "?").toUpperCase();
}

function colorFor(text) {
  let hash = 0;
  for (const ch of String(text || "")) hash = (hash * 31 + ch.charCodeAt(0)) >>> 0;
  return PALETTE[hash % PALETTE.length];
}

export default function ItemImage({ urls = [], alt, className = "" }) {
  const list = urls.filter(Boolean);
  const listKey = list.join("|");
  const [index, setIndex] = useState(0);

  useEffect(() => setIndex(0), [listKey]);

  if (index >= list.length) {
    return (
      <div
        role="img"
        aria-label={alt}
        className={`flex items-center justify-center font-semibold tracking-wide select-none ${colorFor(alt)} ${className}`}
      >
        <span className="text-lg">{initials(alt)}</span>
      </div>
    );
  }

  return (
    <img
      src={list[index]}
      alt={alt}
      loading="lazy"
      onError={() => setIndex((i) => i + 1)}
      className={`object-contain bg-white ${className}`}
    />
  );
}
